import { ref, getDatabase, get, update, push } from "firebase/database";
import { toastrError, toastrSuccess } from "../components/toastr";
import { v4 } from "uuid";

async function userInfo(payload) {
  try {
    const database = getDatabase();
    const userInfoRef = ref(database, "userInfo");
    await push(userInfoRef, payload);
    return true;
  } catch (err) {
    toastrError("Failed to save user info");
    throw err;
  }
}

const addUser = async (setLoader, setUser, email) => {
  const database = getDatabase();
  const data = {
    companyName: "",
    country: "",
    email: email,
    id: v4(),
    userType: "free",
  };
  setLoader(true);
  try {
    const res = await userInfo(data);
    if (res) {
      const cartRef = ref(database, "userInfo");
      const snapshot = await get(cartRef);
      const dbData = snapshot.val();
      if (dbData) {
        const projects = Object.values(dbData);
        setUser(projects);
      }
      toastrSuccess("User Created Successfully");
    }
    setLoader(false);
  } catch (err) {
    setLoader(false);
    toastrError(err);
  }
};

const getAllUsers = async (setLoader, setUser, email) => {
  const database = getDatabase();
  const cartRef = ref(database, "userInfo");
  setLoader(true);
  try {
    const snapshot = await get(cartRef);
    setLoader(false);
    const data = snapshot.val();
    if (data) {
      const projects = Object.values(data);
      setUser(projects);
    } else {
      await addUser(setLoader, setUser, email);
    }
  } catch (err) {
    setLoader(false);
    toastrError(err);
  }
};

const updateUser = (setLoading, data, email, setOpen, userId) => {
  const database = getDatabase();
  setLoading(true);
  const userSnapshot = ref(database, `userInfo`);
  get(userSnapshot)
    .then((snapshot) => {
      if (snapshot.exists()) {
        const userData = snapshot.val();
        const userKey = Object.keys(userData).find(
          (key) => userData[key].email === email
        );
        if (userKey) {
          const userRef = ref(database, `userInfo/${userKey}`);
          update(userRef, data)
            .then(() => {
              if (userId) {
                const publicRef = ref(database, `publicSettings/${userId}`);
                update(publicRef, { maskName: data.maskName || false });
              }
              toastrSuccess("Data updated successfully!");
              setOpen(true);
              setLoading(false);
            })
            .catch((err) => {
              toastrError(err);
              setLoading(false);
            });
        } else {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    })
    .catch((err) => {
      setLoading(false);
      toastrError(err);
    });
};

const updateCustomer = (setLoading, data, id, setOpen) => {
  const database = getDatabase();
  setLoading(true);
  const userSnapshot = ref(database, `customers`);
  get(userSnapshot)
    .then((snapshot) => {
      if (snapshot.exists()) {
        const userData = snapshot.val();
        const userKey = Object.keys(userData).find(
          (key) => userData[key].id === id
        );
        if (userKey) {
          const userRef = ref(database, `customers/${userKey}`);
          update(userRef, data)
            .then(() => {
              toastrSuccess("Data updated successfully!");
              setOpen(true);
              setLoading(false);
            })
            .catch((err) => {
              toastrError(err);
              setLoading(false);
            });
        } else {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    })
    .catch((err) => {
      setLoading(false);
      toastrError(err);
    });
};

export { userInfo, getAllUsers, addUser, updateUser, updateCustomer };
